import { collection, onSnapshot, query } from 'firebase/firestore';
import { useEffect } from 'react';
import { markLastMessageAsRead } from '../services/chatService';

/**
 * Підписка на повідомлення вибраного чату
 */
export const useChatMessagesSubscription = ({
  user,
  db,
  selectedChatId,
  messagesCacheRef,
  setChats,
}) => {
  useEffect(() => {
    if (!user || !selectedChatId) return;

    const messagesRef = collection(db, 'chats', selectedChatId, 'messages');
    const q = query(messagesRef);

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const messagesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Сортуємо повідомлення за часом
      const sortedMessages = messagesData.sort((a, b) => a.timestamp - b.timestamp);

      // Кешуємо
      messagesCacheRef.current[selectedChatId] = sortedMessages;

      // Оновлюємо стан чатів
      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.id === selectedChatId ? { ...chat, messages: sortedMessages } : chat
        )
      );

      // Позначаємо останнє як прочитане (якщо потрібно)
      const lastMessage = sortedMessages[sortedMessages.length - 1];
      if (lastMessage && !lastMessage.readed && lastMessage.sender === 'client') {
        markLastMessageAsRead(db, selectedChatId);
      }
    });

    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [db, user, selectedChatId, messagesCacheRef, setChats]);
};
